import ListEmptyView from "./ListEmptyView";

/**
 * Container component for empty list state
 *
 * This is a stateless container that renders the ListEmptyView component.
 * Currently has no additional logic, but provides a consistent entry point
 * for the component.
 */
export default ListEmptyView;
